import React, { useState, useMemo, useCallback, useEffect } from "react"
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { CurrentCardStatus, CardActionType } from '../types'
import { FreezeActionType } from '../components/FreezeModal/index.type'
import { usePhysicalCardInfo } from "@/hooks"
import { APIWeb } from '@/api/index'
import { Toast } from 'react-vant'
import FreezeModal from '../components/FreezeModal'
import CardSwiper from '../components/CardSwiper'
import CardActions from '../components/CardActions'
import TransactionRecords from '../components/TransactionRecords'

export default React.memo(function PhysicalCard() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [showFreezeModal, setShowFreezeModal] = useState(false)
  const { cardInfo, actions: cardActions } = usePhysicalCardInfo()
  const [freezeActionType, setFreezeActionType] = useState<FreezeActionType>(FreezeActionType.Freeze)
  const [currentCardId, setCurrentCardId] = useState<number>(0)

  // 实体卡列表数据（后续从接口获取，需要过滤出实体卡）
  const cards = useMemo<CardInfoResponse[]>(() => {
    if (!cardInfo?.id) return []
    // 目前只有一张卡，后续会是卡片列表
    return [cardInfo]
  }, [cardInfo])

  // 初始化当前卡片ID
  useEffect(() => {
    if (cardInfo?.id && !currentCardId) {
      setCurrentCardId(cardInfo.id)
    }
  }, [cardInfo?.id, currentCardId])

  // 处理卡片切换
  const handleCardChange = useCallback((cardId: number, index: number) => {
    console.log('切换到实体卡:', cardId, '索引:', index)
    setCurrentCardId(cardId)
  }, [])

  const handleCardAction = useCallback(async (actionType: CardActionType) => {
    switch (actionType) {
      case CardActionType.CardInfo:
        navigate('/card/card-info')
        break
      case CardActionType.FreezeUnfreeze:
        Toast.loading(t('同步卡片状态'))
        try {
          const result = await APIWeb.syncCardStatus()
          Toast.clear()
          if (result?.status === CurrentCardStatus.Active) {
            setShowFreezeModal(true)
            setFreezeActionType(FreezeActionType.Freeze)
          } else if (result?.status === CurrentCardStatus.Frozen) {
            setShowFreezeModal(true)
            setFreezeActionType(FreezeActionType.Unfreeze)
          }
        } catch (error) {
          console.error('同步卡片状态失败:', error)
          Toast.clear()
        }
        break
      case CardActionType.LimitAdjustment:
        navigate('/card/set-limit')
        break
      case CardActionType.Management:
        Toast.info(t('即将上线'))
        break
    }
  }, [navigate, t])

  const handleFreezeActionComplete = useCallback(async () => {
    cardActions.refreshCardInfo()
  }, [cardActions])

  const handleCloseFreezeModal = useCallback(() => setShowFreezeModal(false), [])

  return (
    <div className="px-6 py-6">
      {/* 实体卡 Swiper */}
      <CardSwiper cards={cards} onCardChange={handleCardChange} />

      <div>
        <div className="text-2.5 text-[#000000]/50 text-center my-4">{t('关联账户')} ({t('实体卡消费仅支持Current Account')})</div>
        <div className="relative min-h-15 overflow-hidden border-solid border-[0.5px] border-[#E5E5E5] rounded-4 px-4 pt-5 pb-2.5">
          <div className="absolute left-0 top-0 flex items-center">
            <div className="text-white min-w-30 bg-[var(--primary-color)] px-2 py-1 text-2.5 rounded-br-5 text-center">{t('Current Account')}</div>
            <div className="flex items-center justify-center ml-2">
              <img src="/icon/mini-card.svg" alt="card" />
              <span className="text-2.5 ml-1">9785</span>
            </div>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <img className="w-6 h-6" src="/images/home/usd.png" alt="usd" />
              <span className="ml-2">USD</span>
            </div>
            <div className="text-right">
              <div className="font-semibold text-base text-black">1,000.72834</div>
              <div className="text-xs text-[#1A1A1A]/60">≈ 1000 USD</div>
            </div>
          </div>
        </div>
      </div>

      {/* 卡片操作按钮 */}
      <CardActions onActionClick={handleCardAction} />

      {/* 交易记录 */}
      {/* <TransactionRecords cardId={currentCardId} /> */}

      {/* 冻结/解冻弹窗 */}
      <FreezeModal
        freezeActionType={freezeActionType}
        visible={showFreezeModal}
        onClose={handleCloseFreezeModal}
        onFreezeAction={handleFreezeActionComplete}
      />
    </div>
  )
})
